import React from 'react';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { translations } from 'src/constants/translations';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  accordionStateOptions, AccordionStateType,
  IMarketplaceModulePrimarySectionType,
} from 'src/components/profileComponents/Marketplace/types';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { InfoTag } from 'src/components/profileComponents/Marketplace/components/Filters/components/InfoTag';
import { useStyles } from './styles';

interface LocationGroupProps {
  item: IMarketplaceModulePrimarySectionType,
  lang: string
  onTrash: () => void
  onChange: (item: IMarketplaceModulePrimarySectionType) => void,
}

export const LocationGroup: React.FC<LocationGroupProps> = ({
  item, lang, onTrash, onChange,
}) => {
  const styles = useStyles();
  return (
    <>
      <GroupWrapper
        name="Locations"
        startIcon={<FmdGoodOutlinedIcon />}
        actions={(
          <GroupWrapperFiltersAction
            onTrash={onTrash}
            onDrag={() => {}}
          />
        )}
      >
        <div className={styles.locationsFields}>
          <BoxFormTextField
            label={translations.projectName}
            name="name"
            defaultValue={item.name?.[lang]}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'name', lang, event.target.value));
            }}
          />
          <BoxFormTextField
            label={translations.callToAction}
            name="callToAction"
            defaultValue={item.callToActionText ? item.callToActionText[lang || ''] : ''}
            onChange={(event) => {
              onChange(updateTranslatedField(item, 'callToActionText', lang, event.target.value));
            }}
          />
          <BoxFormAutocomplete
            label={translations.accordionState}
            name="accordionState"
            defaultValue={{ label: item.accordionState, value: item.accordionState }}
            options={accordionStateOptions}
            onChange={(event: {label: string, value: AccordionStateType}) => {
              onChange({ ...item, accordionState: event.value });
            }}
          />
        </div>
        <InfoTag
          item={item.tooltip}
          lang={lang}
          onChange={(tooltip) => onChange({ ...item, tooltip })}
        />
      </GroupWrapper>
    </>
  );
};
